import { BottomNav } from "@base/ui/BottomNav";
import { useSafeAreaInset } from "@base/ui/SafeArea/useSafeAreaInset";
import { ProjectsGrid } from "@features/home/ui/ProjectsGrid";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/projects/")({
  component: ProjectsPage,
});

function ProjectsPage() {
  const { bottom } = useSafeAreaInset();

  return (
    <div
      className="p-4 min-h-dvh pb-[var(--bottom-nav-space)] md:px-0 md:pt-8 md:pb-8"
      style={{ "--bottom-nav-space": `calc(6rem + ${bottom}px)` } as React.CSSProperties}
    >
      <h1 className="mb-4 text-title5 text-gray-1000">Projects</h1>
      <ProjectsGrid />
      <BottomNav />
    </div>
  );
}
